import { takeLatest, put } from 'redux-saga/effects';
import * as TYPES from '../actions/types';
import { SaveServiceSetDDL, loaderAction, saveStaffList, saveStaffNotificationSetting ,saveStaffNotificationMedium } from '../actions';
import { ServiceSetDDLResponse } from 'src/dataModels/staffResponsesModels';
import { staffServicess } from 'src/services/staffServices';
import { NotificationManager } from "react-notifications";
import NOTIFICATION_MESSAGE from 'src/helper/notification-messages';
import { StaffResponse } from 'src/dataModels/clientResponse';

export function* GetServiceSetDDLSaga() {
    yield takeLatest(TYPES.GET_SERVICE_SET_DDL, ServiceSetDDLWorker)
}
function* ServiceSetDDLWorker(param: any) {
    try {
        yield put(loaderAction(true));
        const response: ServiceSetDDLResponse = yield staffServicess.serviceSetDDL(param['payload'])
        yield put(SaveServiceSetDDL(response));
        yield put(loaderAction(false));
    }
    catch (err) {
        yield put(loaderAction(false));

    }
}

export function* GetStaffNotificationSettingSaga() {
    yield takeLatest(TYPES.GET_STAFF_NOTIFICATION_SETTING, GetStaffNotificationSettingWorker)
}
function* GetStaffNotificationSettingWorker(param: any) {
    try {
        yield put(loaderAction(true));
        const response: ServiceSetDDLResponse = yield staffServicess.getstaffNotificationSetting(param['payload'])
        yield put(saveStaffNotificationSetting(response));
        yield put(loaderAction(false));
    }
    catch (err) {
        yield put(loaderAction(false));

    }
}


export function* SaveStaffNotificationSaga() {
    yield takeLatest(TYPES.SAVE_STAFF_NOTIFICATION, GetStaffNotificationWorker)
}
function* GetStaffNotificationWorker(param: any) {
    try {
        yield put(loaderAction(true));
        yield staffServicess.savestaffNotification(param['payload'])
        NotificationManager.success(NOTIFICATION_MESSAGE.SUCCESS);
        yield put(loaderAction(false));
    }
    catch (err) {
        yield put(loaderAction(false));

    }
}

export function* getStaffListSaga() {
    yield takeLatest(TYPES.GET_STAFF_LIST, staffListWorker);
}

function* staffListWorker() {
    try {
        // yield put(loaderAction(true));
        const response: StaffResponse = yield staffServicess.staffList();
        // yield put(loaderAction(false));
        yield put(saveStaffList(response.resultData));
    } catch (err) {
    }
}
export function* GetStaffNotificationMediumSettingSaga() {
    yield takeLatest(TYPES.GET_STAFF_NOTIFICATION_MEDIUM_SETTING, GetStaffNotificationMediumSettingWorker)
}
function* GetStaffNotificationMediumSettingWorker(param: any) {
    try {
        yield put(loaderAction(true));
        const response: ServiceSetDDLResponse = yield staffServicess.getstaffNotificationMediumSetting(param['payload'])
        yield put(saveStaffNotificationMedium(response));
        yield put(loaderAction(false));
    }
    catch (err) {
        yield put(loaderAction(false));

    }
}

export function* SaveStaffNotificationMediumSaga() {
    yield takeLatest(TYPES.SAVE_STAFF_NOTIFICATION_MEDIUM_SETTING, SaveStaffNotificationMediumSagaWorker)
}
function* SaveStaffNotificationMediumSagaWorker(param: any) {
    try {
        yield put(loaderAction(true));
        const response: any = yield staffServicess.saveStaffNotificationMediumSettings(param['payload'])
        if (response != undefined)
            NotificationManager.success(NOTIFICATION_MESSAGE.SUCCESS);
        yield put(loaderAction(false));
    }
    catch (err) {
        yield put(loaderAction(false));

    }
}
